import { render, staticRenderFns } from "./CollectionFilterControlTypeSelect.vue?vue&type=template&id=add48c46"
import script from "./CollectionFilterControlTypeSelect.vue?vue&type=script&setup=true&lang=js"
export * from "./CollectionFilterControlTypeSelect.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports